import { render, staticRenderFns } from "./InputHoriz.vue?vue&type=template&id=26b80ef6&lang=true&"
import script from "./InputHoriz.vue?vue&type=script&lang=js&"
export * from "./InputHoriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports